/* REACT HOT LOADER */ if (module.hot) { (function () { var ReactHotAPI = require("/mnt/xvdb/jenkins/workspace/ProFrontend-Mamobility-Device/node_modules/react-hot-api/modules/index.js"), RootInstanceProvider = require("/mnt/xvdb/jenkins/workspace/ProFrontend-Mamobility-Device/node_modules/react-hot-loader/RootInstanceProvider.js"), ReactMount = require("react-dom/lib/ReactMount"), React = require("react"); module.makeHot = module.hot.data ? module.hot.data.makeHot : ReactHotAPI(function () { return RootInstanceProvider.getRootInstances(ReactMount); }, React); })(); } try { (function () {

"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _style3 = require("antd/lib/breadcrumb/style");

var _breadcrumb = require("antd/lib/breadcrumb");

var _breadcrumb2 = _interopRequireDefault(_breadcrumb);

var _jsx2 = require("babel-runtime/helpers/jsx");

var _jsx3 = _interopRequireDefault(_jsx2);

var _style4 = require("antd/lib/message/style");

var _message = require("antd/lib/message");

var _message2 = _interopRequireDefault(_message);

var _extends2 = require("babel-runtime/helpers/extends");

var _extends3 = _interopRequireDefault(_extends2);

var _assign = require("babel-runtime/core-js/object/assign");

var _assign2 = _interopRequireDefault(_assign);

var _getPrototypeOf = require("babel-runtime/core-js/object/get-prototype-of");

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require("babel-runtime/helpers/classCallCheck");

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require("babel-runtime/helpers/createClass");

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require("babel-runtime/helpers/possibleConstructorReturn");

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require("babel-runtime/helpers/inherits");

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _reactRouter = require("react-router");

var _tpl = require("tpl");

var _tpl2 = _interopRequireDefault(_tpl);

var _comps = require("comps");

var _form = require("./form");

var _form2 = _interopRequireDefault(_form);

var _config = require("util/config");

var _tool = require("util/tool");

require("./index.less");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Main = function (_Component) {
  (0, _inherits3.default)(Main, _Component);

  function Main(props, context) {
    (0, _classCallCheck3.default)(this, Main);

    // console.log(this.props)
    var _this = (0, _possibleConstructorReturn3.default)(this, (Main.__proto__ || (0, _getPrototypeOf2.default)(Main)).call(this, props, context));

    _this.state = {
      id: "",
      formData: {},
      initInfo: {
        name: "",
        factoryName: "",
        accessType: "1",
        operatingSystem: "1",
        networkType: "1",
        deviceTypeId: "",
        productTemplate: '2',
        accessDeviceType: '',
        deviceTypeIdFarther: "",
        pictureUrl: "",
        accessDeviceTypeName: '',
        pictureId: "",
        remark: "",
        childTypeData: [],
        isEdit: false,
        imgObj: {
          previewVisible: false,
          previewImage: "",
          fileList: [],
          pictureId: ""
        },
        lock: false
      },
      deviceTypeS: [],
      deviceTypeObj: {
        accessDeviceType: "",
        accessDeviceTypeName: "",
        deviceTypeDesc: ""
      }
    };
    return _this;
  }

  (0, _createClass3.default)(Main, [{
    key: "SubmitClick",
    value: function SubmitClick(e) {
      var _this2 = this;

      e.preventDefault();

      var pictureId = this.props.initInfo.pictureId;
      var deviceTypes = this.props.deviceTypes;

      this.props.form.validateFields(function (err, values) {
        if (!err) {
          var tmp = {
            accessType: "999",
            networkType: "999",
            operatingSystem: "999",
            // accessDeviceType: "999",
            productTemplate: '2'
            // accessDeviceTypeName: "E10"
          };
          var o = (0, _assign2.default)((0, _extends3.default)({}, values, {
            partList: _this2.props.initInfo.partList
          }), tmp, {
            pictureId: pictureId
          });

          // if (values.accessDeviceType) {
          //   let tmp = {}
          //   deviceTypes.map(item => {
          //     if (item.deviceTypeNumber == values.accessDeviceType) {
          //       tmp = {
          //         accessDeviceType: values.accessDeviceType,
          //         accessDeviceTypeName: item.deviceTypeName,
          //         deviceTypeDesc: item.deviceTypeDescription
          //       }
          //     }
          //   })
          //   o = Object.assign({}, o, tmp)
          // }

          _this2.props.submitCallBack(o);
        }
      });
    }
  }, {
    key: "componentWillMount",
    value: function componentWillMount() {
      // 获取数据

      var _props = this.props,
          params = _props.params,
          getDeviceType = _props.getDeviceType,
          fetchData = _props.fetchData;

      params.id && this.props.fetchPosts(_config.apiJson.getProduct, { productId: params.id });

      // getDeviceType({
      // }).then(() => {
      //   let {product} = this.props

      //   this.setState({
      //     'deviceTypeS': product.dTypes,
      //     'deviceTypeObj': {
      //       accessDeviceType: product.dTypes[0]['deviceTypeNumber'],
      //       accessDeviceTypeName: product.dTypes[0]['deviceTypeName'],
      //       deviceTypeDesc: product.dTypes[0]['deviceTypeDescription']
      //     }
      //   })
      // })
    }
  }, {
    key: "submitCallBack",
    value: function submitCallBack(values) {
      var _this3 = this;

      var params = this.props.params;

      values = params.id ? (0, _assign2.default)(values, { id: params.id }) : values;
      // this.setState(Object.assign(this.state.initInfo, { lock: true }));
      var url = params.id ? _config.apiJson.updateProduct : _config.apiJson.insertProduct;
      var mes = params.id ? "更新成功" : "创建成功";
      (0, _tool.http)(url, values).then(function (res) {
        if (res) {
          _message2.default.success(mes);
          _this3.props.router.push({
            pathname: "/"
          });
        }
      }).catch(function (res) {
        _message2.default.error(res.errmsg);
        _this3.setState((0, _assign2.default)(_this3.state.initInfo, { lock: false }));
      });
    }
  }, {
    key: "cancleClick",
    value: function cancleClick(e) {
      this.props.router.push({ pathname: "/" });
    }
  }, {
    key: "childSelectChange",
    value: function childSelectChange(val) {
      var deviceTypeS = this.state.deviceTypeS;

      var o = {};
      deviceTypeS.map(function (item) {
        if (item.deviceTypeNumber == val) {
          o = {
            accessDeviceType: val,
            accessDeviceTypeName: item.deviceTypeName,
            deviceTypeDesc: item.deviceTypeDescription
          };
        }
      });
      this.setState({
        deviceTypeObj: o
      });
      // const options = {
      //   id
      // }
      // http(apiJson.getDeviceType, options).then(res => {
      //   if (res) {
      //     this.setState(Object.assign(this.state.initInfo, {childTypeData: res}))
      //   }
      // }).catch(res => {

      // })
    }
  }, {
    key: "render",
    value: function render() {
      var _props2 = this.props,
          routes = _props2.routes,
          params = _props2.params,
          fetchData = _props2.fetchData;

      var fetchDatas = fetchData.data;
      var _state = this.state,
          initInfo = _state.initInfo,
          deviceTypeS = _state.deviceTypeS;

      var imgUrl = fetchDatas.pictureUrl ? "" + _config.target + (fetchDatas.pictureUrl || "") : "";
      var formInfo = fetchDatas.name ? (0, _assign2.default)(initInfo, fetchDatas) : initInfo;
      formInfo.isEdit = fetchDatas.name ? true : false;
      formInfo.imgObj.fileList = imgUrl ? [{ uid: -1, url: imgUrl }] : [];
      function itemRender(route, params, routes, paths) {
        var last = routes.indexOf(route) === routes.length - 1;
        return last ? (0, _jsx3.default)("span", {}, void 0, route.breadcrumbName) : (0, _jsx3.default)(_reactRouter.Link, {
          to: "/" + paths.join("/")
        }, void 0, route.breadcrumbName);
      }
      return (0, _jsx3.default)("div", {
        className: "product-add"
      }, void 0, (0, _jsx3.default)("div", {
        className: "product-bread"
      }, void 0, (0, _jsx3.default)(_breadcrumb2.default, {
        routes: routes,
        params: params,
        itemRender: itemRender,
        separator: ">"
      })), (0, _jsx3.default)("div", {
        className: "product-cont"
      }, void 0, (0, _jsx3.default)("div", {
        className: "cont"
      }, void 0, _react2.default.createElement(_form2.default, {
        deviceTypes: deviceTypeS,
        handleSubmit: this.SubmitClick,
        cancleClick: this.cancleClick,
        submitCallBack: this.submitCallBack.bind(this),
        ref: "form",
        initInfo: formInfo,
        childSelectChange: this.childSelectChange.bind(this)
      }))));
    }
  }]);
  return Main;
}(_react.Component);

exports.default = (0, _tpl2.default)({
  id: "productAdd", // 应用关联使用的redux
  component: Main, // 接收数据的组件入口
  url: ""
});

/* REACT HOT LOADER */ }).call(this); } finally { if (module.hot) { (function () { var foundReactClasses = module.hot.data && module.hot.data.foundReactClasses || false; if (module.exports && module.makeHot) { var makeExportsHot = require("/mnt/xvdb/jenkins/workspace/ProFrontend-Mamobility-Device/node_modules/react-hot-loader/makeExportsHot.js"); if (makeExportsHot(module, require("react"))) { foundReactClasses = true; } var shouldAcceptModule = true && foundReactClasses; if (shouldAcceptModule) { module.hot.accept(function (err) { if (err) { console.error("Cannot apply hot update to " + "index.jsx" + ": " + err.message); } }); } } module.hot.dispose(function (data) { data.makeHot = module.makeHot; data.foundReactClasses = foundReactClasses; }); })(); } }


//////////////////
// WEBPACK FOOTER
// ./src/containers/product/equipment/index.jsx
// module id = 1054
// module chunks = 0